<template>
  <div>
    <el-upload
      ref="fileUploadControl"
      :action="fileUploadTarget"
      :headers="uploadHeaders"
      :data="uploadParam"
      :show-file-list="showFileList"
      :list-type="showType"
      :before-upload="checkBeforeUpload"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadFailed"
      :on-preview="handleFilePreview"
      :on-remove="handleFileRemove"
      :file-list="fileList"
      :accept="acceptFileType"
      name="file">
      <slot></slot>
      <div v-if="tips" slot="tip" class="el-upload__tip">{{ tips }}</div>
    </el-upload>
  </div>
</template>

<script>
import { tokenUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import { mapState } from 'vuex'
import baseApi from '@/api/base'
export default {
  name: 'FileUpload',
  props: {
    showFileList: {
      type: Boolean,
      default: true
    },
    showType: {
      type: String,
      default: 'text'
    },
    uploadParam: {
      type: Object,
      default: () => {
        return {}
      }
    },
    saveItem: {
      type: Array,
      default: () => {
        return []
      }
    },
    tips: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 1
    },
    limitSize: {
      // 文件上传体积, 以KB为单位
      type: Number,
      default: -1
    },
    uploadImage: {
      type: Boolean,
      default: false
    },
    isClearFile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fileList: [],
      acceptFileType: ''
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    }
  },
  watch: {
    fileList (val) {
      this.$emit('input', val)
    },
    isClearFile (val) {
      if (val) {
        this.clearFileList()
      }
    }
  },
  activated () {
    this.clearFileList()
  },
  created () {
    if(this.saveItem){
      this.fileList = this.saveItem
    }
    if (!this.uploadImage) {
      this.acceptFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
    } else {
      this.acceptFileType = 'image/*'
    }
  },
  methods: {
    clearFileList () {
      this.fileList = []
    },
    handleFilePreview (file) {
      if(file.url){
        window.open(commonUtils.getImageUrl(file.url));
        return 
      }
      window.open(commonUtils.getImageUrl(file.response.resultData.fileDTO.fileUri))
    },
    checkBeforeUpload (file) {
      if (!this.uploadImage) {
        if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel') {
          if (this.fileList.length >= this.limit) {
            this.$alert('不能上传超过' + this.limit + '个文件', '提示')
            return false
          }
          return true
        } else {
          this.$message.error('上传文件不是excel文件,请下载模板文件')
          return false
        }
      } else {
        if (file.type.substr(0, 5) !== 'image') {
          this.$message.error('只能上传图片文件，请重新上传')
          return false
        }
      }
      // console.log(file)
      if (this.limitSize > 0 && file.size > (this.limitSize * 1024)) {
        this.$alert('所选文件体积超过' + this.limitSize + 'KB', '提示')
        return false
      }

      this.$emit('beginUpload', file)
    },
    handleUploadSuccess (response, file) {
      if (response.resultCode === '0') {
        this.fileList.push(file)
        this.$emit('uploaded', file.response.resultData.fileDTO)
      } else {
        this.$message.error({ message: response.resultMsg, showClose: true })
        this.handleFileRemove()
      }
    },
    handleUploadFailed () {
      this.$message.error({ message: '服务器异常，上传失败！', showClose: true })
    },
    handleFileRemove (file) {
      if (file && file.response && file.response.resultData && file.response.resultData.fileDTO) {
        baseApi.deleteFile({ fileId: file.response.resultData.fileDTO.fileId }).then((response) => {
          if (response.data.resultCode === '0') {
            this.$message.warning('删除文件成功')
            this.$emit('removed')
          }
          this.clearFileList()
        })
      }else if(this.saveItem){
        baseApi.deleteFile({ fileId: this.fileList[0].fileId }).then((response) => {
          if (response.data.resultCode === '0') {
            this.$message.warning('删除文件成功')
            this.$emit('removed',)
            this.fileList=[]
          }
          this.clearFileList()
        })
      }
    },
    getClearFiles () {
      this.$refs.fileUploadControl.clearFiles()
      this.clearFileList()
    }
  }
}
</script>
